import React, { Fragment } from 'react'

import { media } from '../styles/tools'

import Space from '../components/Space'
import FlagVideo from '../components/FlagVideo'
import {
  DecideWhenToShowFooter,
  FooterContent,
  FooterData,
} from '../components/Footer'
import { Headline, BoldText } from '../styles/typography'
import NewsletterForm from '../components/NewsletterForm'

const NewsletterFooter = props => (
  <DecideWhenToShowFooter>
    <FooterContent {...props}>
      <FlagVideo
        css={{ height: '100%', position: 'absolute', top: 0, left: 0 }}
      />
      <div
        css={{
          display: 'grid',
          gridTemplate: "'. details .' / 1fr 8fr 1fr",
          [media.tabletLg]: {
            gridTemplate: "'. form . details' / 1fr 3fr 3rem 2fr",
          },
          alignItems: 'center',
          width: '100%',
          position: 'relative',
        }}
      >
        <div
          css={{
            gridArea: 'form',
            [media.max.tabletLg]: { display: 'none' },
          }}
        >
          <NewsletterForm
            defaultMessage={() => (
              <Fragment>
                <Headline as="h2">Want more?</Headline>
                <Space y={20} />
                <BoldText css={{ maxWidth: '28em' }}>
                  Never miss insights and thoughts from Ad Victorem, when you
                  sign up for our blog and receive our monthly newsletter on
                  business, marketing, and design.
                </BoldText>
                <Space y={30} />
              </Fragment>
            )}
            successMessage={() => (
              <BoldText>
                Thank you for signing up for our newsletter.{' '}
                <br css={{ [media.max.laptop]: { display: 'none' } }} />
                We promise no spam, just good stuff! 👏👏
              </BoldText>
            )}
            errorMessage={message => (
              <BoldText dangerouslySetInnerHTML={{ __html: message }} />
            )}
          />
        </div>
        <FooterData css={{ gridArea: 'details' }} />
      </div>
    </FooterContent>
  </DecideWhenToShowFooter>
)

export default NewsletterFooter
